export const GET_KONSELOR_SESSION_REQUEST = "GET_KONSELOR_SESSION_REQUEST";
export const GET_KONSELOR_SESSION_SUCCESS = "GET_KONSELOR_SESSION_SUCCESS";
export const GET_KONSELOR_SESSION_FAIL = "GET_KONSELOR_SESSION_FAIL";
export const GET_KONSELOR_SESSION_RESET = "GET_KONSELOR_SESSION_RESET";

export const POST_KONSELOR_SESSION_REQUEST = "POST_KONSELOR_SESSION_REQUEST";
export const POST_KONSELOR_SESSION_SUCCESS = "POST_KONSELOR_SESSION_SUCCESS";
export const POST_KONSELOR_SESSION_FAIL = "POST_KONSELOR_SESSION_FAIL";
export const POST_KONSELOR_SESSION_RESET = "POST_KONSELOR_SESSION_RESET";
